import React, { useRef, useState, useEffect } from "react";
import { Button, Table, Upload, Modal } from "antd";
import * as XLSX from "xlsx";
import common_api from "../../config/common_api";
import { triggerNotification } from "./notify";

const ExcelImportPreview = ({ importclick, onComplete, setisloader, reload }) => {
    const fileInputRef = useRef(null);
    const [excelData, setExcelData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);


    useEffect(() => {

        if (importclick) {
            if (importclick) {
                handleImport();
                if (onComplete) onComplete();  // ✅ Reset trigger
            }
        }
    }, [importclick]);
    const handleImport = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
            fileInputRef.current.click();
        }
    };
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const allowedTypes = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
            "application/vnd.ms-excel" // .xls
        ];

        const allowedExtensions = [".xls", ".xlsx"];
        const fileExtension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

        if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
            triggerNotification({
                type: "error",
                title: "Invalid File",
                message: "Only .xlsx or .xls Excel files are allowed.",
            });
            return;
        }
        setSelectedFile(file); // keep for later upload

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const json = XLSX.utils.sheet_to_json(worksheet);
            const expectedKeys = ["prod_id", "type", "store", "active", "sapCustomerNumber", "bc_name", "bcSku"];
            const rowsWithMissingKeys = [];

            json.forEach((row, index) => {
                const missingKeys = expectedKeys.filter(key => !(key in row));
                if (missingKeys.length > 0) {
                    rowsWithMissingKeys.push({ rowIndex: index + 2, missingKeys }); // +2 to match Excel row number (1-based + header)
                }
            });

            if (rowsWithMissingKeys.length > 0) {
                let message = rowsWithMissingKeys
                    .map(row => `Row ${row.rowIndex}: Missing ${row.missingKeys == "active" ? "active status" : row.missingKeys.join(", ")}`)
                    .join("<br/>");

                triggerNotification({
                    type: "error",
                    title: "Missing Data!",
                    message: "Invalid template!"//<span dangerouslySetInnerHTML={{ __html: message }} />
                });
            } else {
                // All required keys exist in each row
                const keys = Object.keys(json[0]);

                const tableColumns = keys.map((key) => ({
                    title: key,
                    dataIndex: key,
                    key,
                }));

                setExcelData(json);
                setColumns(tableColumns);
                setIsModalOpen(true);
            }

        };
        reader.readAsArrayBuffer(file);
    };
    const handleOk = async () => {

        if (!selectedFile) {
            // message.error("No file selected!");
            return;
        }

        const formData = new FormData();
        formData.append("import", selectedFile);
        try {
            setisloader(true)
            let response = await common_api.import_data(formData)
            await reload()
            // message.success("File uploaded successfully!");
            setIsModalOpen(false);
            setSelectedFile(null);
            setExcelData([]);
            setColumns([]);
            triggerNotification(response)

        } catch (error) {
            // message.error("Upload failed: " + error.message);
        }
    };


    return (
        <>
            <input
                type="file"
                accept=".xlsx, .xls"
                style={{ display: "none" }}
                ref={fileInputRef}
                onChange={handleFileChange}
            />

            {/* <Button type="primary" onClick={handleImport}>
                Import
            </Button> */}

            <Modal
                title="Import Preview"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                width={"80%"}
                className="excel_modal"
                onOk={handleOk}
                okText="Import"
            >
                <Table
                    className="excel_modal_tbl"
                    columns={columns}
                    dataSource={excelData}
                    scroll={{ x: 'max-content', y: 500 }}
                    rowKey={(record, index) => index}
                    pagination={{ pageSize: 10 }}
                />

            </Modal>
        </>
    );
};

export default ExcelImportPreview;
